export const EAuthProvider = {
  GOOGLE_EMAIL: 'google_email',
  MICROSOFT_EMAIL: 'microsoft_email',
  GITHUB_EMAIL: 'github_email',
  DISCORD_EMAIL: 'discord_email',
  FACEBOOK_EMAIL: 'facebook_email',
};
